// ----------------------------------------------------------------------------
// Snippet: Free Shipping Progress
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import {formatMoney} from '@shopify/theme-currency';

const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
    if (isNaN(number) || number == null) {
        return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
};


Shopify.freeShippingProgress = () => {

    const _config = {
        progressContainerSelector : '.free-shipping-progress__container',
        minimumSubtotalAttribute  : 'data-minimum-subtotal',
        shopifyAjaxCartURL        : window.localeUrl+'/cart.js',
        freeShippingMessage       : window.translations.freeShippingMessage,
        moneyWithoutCurrency               : theme.moneyWithoutCurrency, // Based on the shop money format
    };

    const _init = () => {

        const _freeShippingProgressHtml = (cart, minimumSubtotal) => {

            let html = '';
            let cartSubtotal;
            
            if (theme.moneyWithoutCurrency == '${{ amount_no_decimals}}') {
                cartSubtotal = parseInt(formatWithDelimiters(cart.items_subtotal_price, 0)*100);
            } else {
                cartSubtotal = parseInt(cart.items_subtotal_price);
            }

            html += '<span class="free-shipping-progress__message">';
            if( cartSubtotal >= minimumSubtotal){// Free Shipping
                html += _config.freeShippingMessage;
            }else{
                const priceDifference = formatMoney(minimumSubtotal - cartSubtotal, _config.moneyWithoutCurrency);
                if (window.localeUrl == '/fr') {
                    html += 'À ' + priceDifference + ' ' + window.translations.notFreeShippingMessage;
                } else {
                    html += priceDifference + ' ' + window.translations.notFreeShippingMessage;
                }
            }
            html += '</span>';

            return html;
        };

        const progressContainers = document.querySelectorAll(_config.progressContainerSelector);
        let minimumSubtotal = false;

        progressContainers?.forEach((progressContainer) => {
            const minimumSubtotalAttribute = progressContainer.getAttribute(_config.minimumSubtotalAttribute);
            
            if(minimumSubtotalAttribute != 'false'){
                minimumSubtotal = parseInt(minimumSubtotalAttribute);
                return false;
            }
        });
        
        if(minimumSubtotal != false){
            fetch(_config.shopifyAjaxCartURL, {
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(cart => {
                    const freeShippingProgressHtml = _freeShippingProgressHtml(cart, minimumSubtotal);
                    progressContainers.forEach((progressContainer) => {
                        progressContainer.innerHTML = freeShippingProgressHtml;
                    });
                });
        }
    };
    return {
        init: (params) => {
            // Configuration
            params = params || {};
            // Merging with defaults.
            Object.assign(_config, params);
            // Action
            _init();
        },
        getConfig: () => {
            return _config;
        }
    };
};

Shopify.freeShippingProgress().init();
